import { TFunction } from 'i18next';
import { z } from 'zod';
import validations from 'utils/validations';

const schema = (t: TFunction) => z.object({
  first_name: validations.requiredString(t('validations:required')),
  last_name: validations.requiredString(t('validations:required')),
  addresses: z.array(z.object({
    state: validations.requiredString(t('validations:required')),
    postal_code: validations.zipCode(t('validations:required')),
    street_address: validations.requiredString(t('validations:required')),
  })),
  emails: z.array(z.object({
    address: validations.email(t('validations:invalidEmail'), t('validations:required')),
    kind: z.string()
      .min(1, t('validations:required'))
      .refine((value) => value === '' || !/^login$/i.test(value), t('validations:email-kind-invalid')),
  })),
  phones: z.array(z.object({
    number: validations.phoneNumber('Phone number is not valid.', t('validations:required')),
    kind: validations.requiredString(t('validations:required')),
  })),
  licenses: z.array(z.object({
    number: validations.requiredString(t('validations:required')),
    state: validations.requiredString(t('validations:required')),
  })),
  parties: z.array(z.object({ kind: validations.requiredString(t('validations:required')) })),
});

export default schema;
